import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-add-adhoc-vehicle',
  templateUrl: './add-adhoc-vehicle.component.html',
  styleUrls: ['./add-adhoc-vehicle.component.scss']
})
export class AddAdhocVehicleComponent {

  _mVehicleTypes: any[] = [];
  _mDriversData: any[] = [];
  registrationNo: any = '';
  vehicleType: any = '';
  mapToExistingDriver: boolean = false;
  driverName: any = '';
  licenseNumber: any = '';
  contactNumber: any = '';
  mVendorMasters: any = '';
  _mVMData: any = [];
  remark: any = '';
  mSubVendorA: any = '';
  mSubVendorB: any = '';
  mDCO: any = '';
  _mSUBAData: any[] = [];
  _mSUBBData: any[] = [];
  _mDCOData: any[] = [];
  isSubVendorFlowEnabled: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddAdhocVehicleComponent>,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    public readonly serviceLocalStorage: ServiceLocalStorage,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngxLoader: NgxUiLoaderService) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.getVehicleTypes();
    this.getAllVendor();
    this.isSubVendorFlowEnabled = this.serviceLocalStorage.isSubVendorFlowEnabled();
  }

  getVehicleTypes() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getVehicleType, success => {
      if (success.status == 200) {
        this._mVehicleTypes = success.body;
        this._mVehicleTypes = this._mVehicleTypes.filter(
          vehicletype => vehicletype.status == AppConstants.ACTIVE_STATUS
        );
      }
    }, error => {
      console.log(error);
    });
  }

  discard_special_char_And_String(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || (k === 32));
  }


  discard_special_char(event) {
    var k;
    k = event.charCode;
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  onStatusChange() {
    this.driverName = '';
    this.mVendorMasters = '';
    this._mDriversData = [];
    this.licenseNumber = '';
    this.contactNumber = '';
    this.remark = '';
    this.mSubVendorA = '';
    this.mSubVendorB = '';
    this.mDCO = '';
  }

  omit_special_char_And_num(event) {
    let k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  getAllVendor() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getVendorMaserBasedOnId + this.data,
      success => {
        if (success != null) {
          this._mVMData = success.body;
        } else {
          this._mVMData = [];
          this.notifyService.showInfo("No Vendors master data found", null);
        }
      },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }

  getDriverDetails(event) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getByvendor + event.target.value, (success) => {
      if (success.status == 200) {
        this._mDriversData = success.body;
      } else {
        this._mDriversData = [];
        this.notifyService.showWarning("No Drivers Found", null);
      }
    },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }

  onSelectDriver(event) {
    const driver = this._mDriversData.find(ele => ele.id == event.target.value);
    if (driver) {
      this.licenseNumber = driver.licenseNumber;
      this.contactNumber = driver.contactNumber;
    }
  }

  onConfirmation() {
    let sendData: any = '';
    const subVendorAObject = this.mSubVendorA ? { id: this.mSubVendorA } : null;
    const subVendorBObject = this.mSubVendorB ? { id: this.mSubVendorB } : null;
    const dcoObject = this.mDCO ? { id: this.mDCO } : null;
    if (this.mapToExistingDriver) {
      sendData = {
        "vehicleTypeId": this.vehicleType,
        "registrationNo": this.registrationNo,
        "siteId": this.data,
        "vendorMasterId": this.mVendorMasters,
        "driverId": this.driverName,
        "mapToExistingDriver": this.mapToExistingDriver,
        "remark": this.remark,
        "subVendorA": subVendorAObject,
        "subVendorB": subVendorBObject,
        "dco": dcoObject,
      }
    } else {
      sendData = {
        "vehicleTypeId": this.vehicleType,
        "registrationNo": this.registrationNo,
        "siteId": this.data,
        "vendorMasterId": this.mVendorMasters,
        "driverName": this.driverName,
        "licenseNumber": this.licenseNumber,
        "contactNumber": this.contactNumber,
        "mapToExistingDriver": this.mapToExistingDriver,
        "remark": this.remark,
        "subVendorA": subVendorAObject,
        "subVendorB": subVendorBObject,
        "dco": dcoObject,
      }
    }
    if (sendData) {
      this.ngxLoader.start();
      this.apiService.doPostRequestWithResponse(ApiConstants.addOutSourceVehicle, sendData, (success) => {
        this.ngxLoader.stop();
        if (success.status == 200) {
          if (success.body.message == 'Added successfully') {
            this.dialogRef.close("");
            this.notifyService.showSuccess(success.body.message, null);
          } else {
            this.notifyService.showWarning(success.body.message, null);
          }
        }
      }, (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError("Failed to add", null);
      });
    }
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  onVendorMasterChange(event: any) {
    this.mSubVendorA = '';
    this.mSubVendorB = '';
    this.mDCO = '';
    this._mSUBAData = [];
    this._mSUBBData = [];
    this._mDCOData = [];
    const vendorId = event.target.value;

    if (vendorId) {
      this.requestServerGetSubVendorA(vendorId);
      this.requestServerGetDCO(vendorId, null);
    }
  }

  onSubVendorAChange(event: any) {
    const subVendorAId = event.target.value;
    const vendorMasterId = this.mVendorMasters;
    this.mSubVendorB = '';
    this.mDCO = '';
    this._mSUBBData = [];
    this._mDCOData = [];

    if (subVendorAId) {
      this.requestServerGetSubVendorB(subVendorAId);
      this.requestServerGetDCO(vendorMasterId, subVendorAId);
    } else if (vendorMasterId) {
      this.requestServerGetDCO(vendorMasterId, null);
    }
  }

  requestServerGetSubVendorA(vendorMasterId: string | number) {
    this._mSUBAData = [];
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getsubvendorAbyvendormaster + vendorMasterId,
      success => {
        if (success.status === 200) {
          this._mSUBAData = success.body;
        } else {
          this._mSUBAData = [];
        }
      },
      error => this.notifyService.showError("Failed to fetch Sub Vendor A data", error)
    );
  }

  requestServerGetSubVendorB(subVendorAId: string | number) {
    this._mSUBBData = [];
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getsubvendorBbysubvendorA + subVendorAId,
      success => {
        if (success.status === 200) {
          this._mSUBBData = success.body;
        } else {
          this._mSUBBData = [];
        }
      },
      error => this.notifyService.showError("Failed to fetch Sub Vendor B data", error)
    );
  }

  requestServerGetDCO(vendorMasterId: string | number, subVendorAId: string | number | null) {
    this._mDCOData = [];
    let apiUrl = 'vendormaster/getdcobyvendormasterorsubvendora';
    const params: string[] = [];
    if (subVendorAId) {
      params.push(`subVendorAId=${subVendorAId}`);
    }
    if (!subVendorAId && vendorMasterId) {
      params.push(`vendorMasterId=${vendorMasterId}`);
    }
    if (params.length > 0) {
      apiUrl += '?' + params.join('&');
    } else {
      return;
    }

    this.apiService.doGetRequestWithResponse(
      apiUrl,
      success => {
        if (success.status === 200) {
          this._mDCOData = success.body;
        } else {
          this._mDCOData = [];
        }
      },
      error => this.notifyService.showError("Failed to fetch DCO data", error)
    );
  }
}
